import React, { useState } from 'react';
import AuthShell from './AuthShell';

const AdminOtpVerify = ({ loading, email, onResend, onVerify }) => {
  const [otp, setOtp] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    onVerify?.(otp);
  };

  return (
    <AuthShell>
      <form onSubmit={handleSubmit} className="auth-form text-start">
        <p className="text-muted mb-4">
          We sent a secure one-time passcode to <strong>{email || 'your email'}</strong>.
          Enter the 6-digit code below to complete verification.
        </p>
        <div className="mb-4">
          <label htmlFor="admin-otp" className="form-label fw-semibold">
            One-Time Passcode
          </label>
          <input
            id="admin-otp"
            type="text"
            className="form-control form-control-lg rounded-pill shadow-sm text-center tracking-wide"
            placeholder="••••••"
            maxLength={6}
            value={otp}
            onChange={(event) => setOtp(event.target.value.replace(/[^0-9]/g, ''))}
            required
            disabled={loading}
          />
        </div>
        <button
          type="submit"
          className="btn btn-primary btn-lg rounded-pill shadow-sm w-100"
          disabled={loading || !otp}
        >
          {loading ? 'Verifying…' : 'Verify Access'}
        </button>
        <button
          type="button"
          className="btn btn-link w-100 mt-3 text-decoration-none"
          onClick={onResend}
          disabled={loading}
        >
          Resend code
        </button>
      </form>
      <div className="auth-footer mt-4 text-center">
        <small className="text-muted">
          Trouble receiving codes? Ensure <strong>admin@toivotek.ai</strong> is whitelisted.
        </small>
      </div>
    </AuthShell>
  );
};

export default AdminOtpVerify;
